import { z } from 'zod'

export const evidenceSchema = z.discriminatedUnion('evidenceKind', [
  z.object({
    evidenceKind: z.literal('link'),
    content: z
      .string()
      .url('Insira um link válido')
      .min(1, 'Link é obrigatório')
  }),
  z.object({
    evidenceKind: z.literal('text'),
    content: z.string().min(1, 'Texto é obrigatório')
  }),
  z.object({
    evidenceKind: z.literal('image'),
    media_id: z.number().min(1, 'Imagem é obrigatória')
  }),
  z.object({
    evidenceKind: z.literal('qr_code'),
    content: z.string().optional().default('')
  }),
  z.object({
    evidenceKind: z.literal('default'),
    content: z.string().default('Completado sem necessidade de evidência')
  })
])

export type EvidenceKind = 'link' | 'text' | 'image' | 'qr_code' | 'default'

export type EvidenceFormData = z.infer<typeof evidenceSchema>
